import { DialogTitle, IconButton, Box } from "@mui/material";
import { Colors } from "../../styles/theme";
import CloseIcon from '@mui/icons-material/Close';

export default function AppDialogTitle({
    title,
    onClose,
    sx
}) {
    return (
        <DialogTitle sx={{ background: Colors.primary, mb: 1, color: Colors.white, ...sx }}>
            <Box display={"flex"} alignItems="center" justifyContent={'space-between'} sx={{height: '14px',}}>
                {title}
                <IconButton onClick={onClose} sx={{ color: Colors.white }}>
                    <CloseIcon />
                </IconButton>
            </Box>
        </DialogTitle>
    )
}